module.exports = __webpack_public_path__ + "static/img/zengom1_bg_2.f027be6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/m1/zengom1_bg_2.png
// module id = 658
// module chunks = 0